<template>
    <footer class="footer pt-md-5">
        <div class="container pt-3">
            <div class="row gy-3 position-relative pb-3">
                <div class="col-lg-3 col-sm-6 mb-4 mb-lg-0">
                    <div class="logo">
                        <router-link :to="{ path: `/${$i18n.locale}` }">
                            <img loading="lazy" src="../../assets/images/logo-old-dark.svg" alt="logo"
                                style="width: auto !important;" width="170" height="100" />
                        </router-link>
                        <p class="py-4 desc">
                            {{ $t('e_learning_description') }}
                        </p>
                        <!-----Start Of Social Links--------------->
                        <div class="d-flex d-lg-block align-items-center">
                            <div class="social">
                                <div class="gap-4 d-flex align-items-center ">
                                    <div class="ins">
                                        <a href="footerData?.general?.instagram" target="_blank" aria-label="twitter">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20"
                                                viewBox="0 0 22 20" fill="none">
                                                <path
                                                    d="M17.3259 0H20.6992L13.3293 8.47278L22 20H15.2112L9.8945 13.0079L3.80967 20H0.4345L8.31783 10.9372L0 0.000921999H6.96117L11.7673 6.39192L17.3259 0ZM16.1425 17.9699H18.0116L5.9455 1.92412H3.93983L16.1425 17.9699Z"
                                                    fill="white" />
                                            </svg>
                                        </a>
                                    </div>
                                    <div class="twitter">
                                        <a href="footerData?.general?.twitter" target="_blank" aria-label="twitter">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <path
                                                    d="M12 16C13.0609 16 14.0783 15.5786 14.8284 14.8284C15.5786 14.0783 16 13.0609 16 12C16 10.9391 15.5786 9.92172 14.8284 9.17157C14.0783 8.42143 13.0609 8 12 8C10.9391 8 9.92172 8.42143 9.17157 9.17157C8.42143 9.92172 8 10.9391 8 12C8 13.0609 8.42143 14.0783 9.17157 14.8284C9.92172 15.5786 10.9391 16 12 16Z"
                                                    stroke="white" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path
                                                    d="M3 16V8C3 6.67392 3.52678 5.40215 4.46447 4.46447C5.40215 3.52678 6.67392 3 8 3H16C17.3261 3 18.5979 3.52678 19.5355 4.46447C20.4732 5.40215 21 6.67392 21 8V16C21 17.3261 20.4732 18.5979 19.5355 19.5355C18.5979 20.4732 17.3261 21 16 21H8C6.67392 21 5.40215 20.4732 4.46447 19.5355C3.52678 18.5979 3 17.3261 3 16Z"
                                                    stroke="white" stroke-width="1.5" />
                                                <path d="M17.5 6.511L17.51 6.5" stroke="white" stroke-width="1.5"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </a>
                                    </div>
                                    <div class="">
                                        <a href="footerData?.general?.linkedin" target="_blank" aria-label="linked in">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26"
                                                viewBox="0 0 26 26" fill="none">
                                                <path
                                                    d="M22.9742 17.5175C22.6059 16.51 20.3742 16.3692 19.3342 14.0617C19.2692 13.8883 19.2801 13.7692 19.4534 13.6608C20.2551 13.13 20.8184 12.8375 21.1434 12.22C21.3817 11.7758 21.4142 11.2558 21.23 10.7792C20.9809 10.1183 20.3526 9.69583 19.5834 9.69583C19.3126 9.69583 19.0959 9.75 18.9876 9.77167C18.9984 9.31667 18.9876 8.84 18.9442 8.36333C18.8034 6.70583 18.2184 5.82833 17.6117 5.135C17.2542 4.73417 15.8351 3.25 13.1484 3.25C10.4617 3.25 9.04255 4.73417 8.68505 5.135C8.07838 5.82833 7.49338 6.70583 7.35255 8.36333C7.32005 8.84 7.30922 9.31667 7.30922 9.77167C7.19005 9.73917 6.98422 9.69583 6.71338 9.69583C5.95505 9.69583 5.31588 10.1075 5.06672 10.7792C4.88255 11.245 4.91505 11.7758 5.15338 12.22C5.48922 12.8483 6.04172 13.13 6.84338 13.6608C7.01672 13.78 7.02755 13.8883 6.96255 14.0617C5.91172 16.3692 3.69088 16.51 3.32255 17.5175C3.16005 17.9508 3.26838 18.4383 3.66922 18.85C4.28672 19.4892 5.43505 19.6842 5.66255 19.8358C5.84672 19.9875 5.82505 20.4425 6.34505 20.8108C6.75672 21.0925 7.21172 21.1142 7.69922 21.125C9.11838 21.1792 9.43255 21.4175 9.97422 21.7533C10.6567 22.1758 11.5884 22.75 13.1484 22.75C14.7084 22.75 15.6401 22.1758 16.3226 21.7533C16.8642 21.4175 17.1784 21.1792 18.5976 21.125C19.0851 21.1033 19.5401 21.0925 19.9517 20.8108C20.4826 20.4425 20.4609 19.9875 20.6342 19.8358C20.8617 19.6842 22.01 19.4892 22.6276 18.85C23.0284 18.4383 23.1367 17.9508 22.9742 17.5175ZM21.8584 18.0917C21.4576 18.5142 20.4934 18.6333 19.9842 18.98C19.4642 19.435 19.5509 19.7817 19.3451 19.9225C19.2042 20.02 18.9551 20.0308 18.5651 20.0525C17.0484 20.1067 16.4959 20.3883 15.8351 20.8C14.2859 21.7533 13.4192 21.6667 13.1484 21.6667C12.8776 21.6667 12.0109 21.7533 10.4726 20.7892C9.81172 20.3775 9.27005 20.1067 7.74255 20.0417C7.35255 20.0308 7.10338 20.0092 6.96255 19.9117C6.75672 19.7708 6.83255 19.4242 6.32338 18.9692C5.80338 18.6225 4.85005 18.5033 4.44922 18.0808C4.38422 18.0158 4.33005 17.9292 4.31922 17.9183C4.39505 17.81 4.76338 17.5933 5.03422 17.4417C5.87922 16.9433 7.17922 16.2067 7.97005 14.4625C8.25172 13.7042 8.00255 13.0975 7.45005 12.74C6.20422 11.9492 6.22588 11.9167 6.10672 11.7C6.06392 11.6169 6.03893 11.5259 6.03333 11.4326C6.02773 11.3393 6.04166 11.2459 6.07422 11.1583C6.20422 10.8117 6.56172 10.7792 6.70255 10.7792C6.90838 10.7792 6.89755 10.79 8.40338 11.18C8.38172 9.66333 8.36005 9.17583 8.42505 8.46083C8.54422 7.04167 9.04255 6.37 9.48672 5.86083C9.79005 5.53583 10.9709 4.31167 13.1484 4.33333C15.3259 4.31167 16.5067 5.53583 16.7992 5.86083C17.2434 6.37 17.7417 7.04167 17.8609 8.46083C17.9259 9.17583 17.9042 9.66333 17.8826 11.18C19.3992 10.79 19.3776 10.7792 19.5834 10.7792C19.7351 10.7792 20.0817 10.8117 20.2117 11.1583C20.2876 11.3425 20.2767 11.5375 20.1792 11.7C20.0601 11.9167 20.0817 11.9383 18.8467 12.7508C18.2942 13.1083 18.0451 13.715 18.3267 14.4733C19.1176 16.2175 20.4175 16.9542 21.2626 17.4525C21.5334 17.615 21.9017 17.8208 21.9776 17.9292C21.9776 17.94 21.9126 18.0267 21.8584 18.0917Z"
                                                    fill="white" />
                                            </svg>
                                        </a>
                                    </div>
                                    <div class="facebook">
                                        <a href="footerData?.general?.facebook" target="_blank" aria-label="facebook">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                viewBox="0 0 20 20" fill="none">
                                                <g clip-path="url(#clip0_741_11085)">
                                                    <path
                                                        d="M12.1969 7.47172C11.7731 7.47172 11.4594 7.57859 11.2138 7.71359C11.1744 7.57359 11.045 7.47109 10.8925 7.50172H9.02751C8.84314 7.47109 8.69376 7.62047 8.75064 7.81422V14.6892C8.69376 14.8642 8.84314 15.0142 9.02751 15.0017H10.8925C11.0769 15.0142 11.2263 14.8642 11.2263 14.6798L11.2256 10.5248C11.225 10.523 11.2181 10.3242 11.3438 10.1873C11.4444 10.0786 11.6175 10.023 11.8569 10.023C12.2556 10.023 12.4331 10.1861 12.4994 10.5511V14.6798C12.4338 14.8642 12.5831 15.0142 12.7675 15.0017H14.7331C14.9175 15.0142 15.0669 14.8642 15.0006 14.6798V10.4123C15.0663 8.24234 13.5206 7.47172 12.1969 7.47172ZM14.3988 14.3767H13.1013V10.5511C13.1013 9.81297 12.6244 9.35547 11.8575 9.35547C11.4238 9.35547 11.0863 9.48297 10.8538 9.73422C10.5306 10.0842 10.5556 10.528 10.625 10.6267V14.3767H9.36126V8.13922H10.5588V8.34922C10.5583 8.41178 10.5754 8.4732 10.6083 8.52644C10.6412 8.57968 10.6884 8.62257 10.7445 8.65018C10.8006 8.67779 10.8634 8.689 10.9256 8.68253C10.9879 8.67606 11.047 8.65217 11.0963 8.61359L11.1838 8.54609C11.4369 8.34672 11.6988 8.13984 12.1975 8.13984C12.7138 8.13984 14.3994 8.30422 14.3994 10.413L14.3988 14.3767ZM6.87501 4.35547C6.17376 4.35547 5.60376 4.92547 5.60376 5.62672C5.60376 6.32797 6.17376 6.89797 6.87501 6.89797C7.57626 6.89797 8.14626 6.32797 8.14626 5.62672C8.14626 4.92547 7.57626 4.35547 6.87501 4.35547ZM6.87501 6.23047C6.54251 6.23047 6.27126 5.95922 6.27126 5.62672C6.27126 5.29422 6.54251 5.02297 6.87501 5.02297C7.20751 5.02297 7.47876 5.29422 7.47876 5.62672C7.47876 5.95922 7.20751 6.23047 6.87501 6.23047ZM7.76751 7.47109H5.91251C5.72814 7.47109 5.57876 7.62047 5.62501 7.81422V14.6892C5.57876 14.8642 5.72814 15.0142 5.91251 15.0017H7.76751C7.95189 15.0142 8.10126 14.8642 8.10126 14.6798V7.80484C8.10126 7.71633 8.0661 7.63144 8.00351 7.56885C7.94092 7.50626 7.85603 7.47109 7.76751 7.47109ZM7.50001 14.3767H6.24626V8.13922H7.50001V14.3767Z"
                                                        fill="white" />
                                                    <path
                                                        d="M10 -0.0195312C4.47376 -0.0195312 -0.0212402 4.47547 -0.0212402 10.0017C-0.0212402 15.528 4.47376 20.023 10 20.023C15.5263 20.023 20.0213 15.528 20.0213 10.0017C20.0213 4.47547 15.5263 -0.0195312 10 -0.0195312ZM10 19.3555C4.84251 19.3555 0.64626 15.1592 0.64626 10.0017C0.64626 4.84422 4.84251 0.647969 10 0.647969C15.1575 0.647969 19.3538 4.84422 19.3538 10.0017C19.3538 15.1592 15.1575 19.3555 10 19.3555Z"
                                                        fill="white" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_741_11085">
                                                        <rect width="20" height="20" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </a>
                                    </div>
                                    <div class="facebook">
                                        <a href="footerData?.general?.facebook" target="_blank" aria-label="twitter">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <path
                                                    d="M19.0201 4.97327C17.631 3.58487 15.8615 2.63953 13.9352 2.2568C12.0089 1.87407 10.0124 2.07113 8.19814 2.82307C6.38385 3.57501 4.83328 4.84805 3.74249 6.48122C2.65171 8.11439 2.0697 10.0343 2.07007 11.9983C2.07007 14.6323 3.1161 17.1586 4.97819 19.0216C6.84029 20.8846 9.36601 21.9319 12.0001 21.9333C13.3036 21.9338 14.5945 21.679 15.8001 21.1833C17.0018 20.676 18.0949 19.9427 19.0201 19.0233C19.9427 18.1008 20.6746 17.0056 21.1739 15.8002C21.6733 14.5949 21.9303 13.303 21.9303 11.9983C21.9303 10.6936 21.6733 9.40166 21.1739 8.1963C20.6746 6.99094 19.9427 5.89575 19.0201 4.97327ZM18.3201 18.3133C16.8901 19.7493 15.0138 20.6557 13.0001 20.8833V14.3233H14.8801C15.1453 14.3233 15.3996 14.2179 15.5872 14.0304C15.7747 13.8428 15.8801 13.5885 15.8801 13.3233C15.8801 13.0581 15.7747 12.8037 15.5872 12.6162C15.3996 12.4286 15.1453 12.3233 14.8801 12.3233H13.0001V9.58327C13.0001 9.31805 13.1054 9.0637 13.293 8.87616C13.4805 8.68863 13.7349 8.58327 14.0001 8.58327H15.2001C15.4653 8.58327 15.7196 8.47791 15.9072 8.29038C16.0947 8.10284 16.2001 7.84849 16.2001 7.58327C16.2001 7.31805 16.0947 7.0637 15.9072 6.87616C15.7196 6.68863 15.4653 6.58327 15.2001 6.58327H13.5001C12.837 6.58327 12.2011 6.84666 11.7323 7.3155C11.2635 7.78434 11.0001 8.42023 11.0001 9.08327V12.3233H9.13007C8.86485 12.3233 8.6105 12.4286 8.42296 12.6162C8.23543 12.8037 8.13007 13.0581 8.13007 13.3233C8.13007 13.5885 8.23543 13.8428 8.42296 14.0304C8.6105 14.2179 8.86485 14.3233 9.13007 14.3233H11.0001V20.8833C9.14296 20.6714 7.39935 19.8814 6.01552 18.6249C4.63169 17.3685 3.67758 15.709 3.28797 13.8809C2.89836 12.0528 3.09293 10.1485 3.8442 8.43693C4.59547 6.7254 5.86547 5.29315 7.47482 4.34249C9.08416 3.39183 10.9515 2.97081 12.8131 3.13889C14.6747 3.30697 16.4364 4.05566 17.8494 5.27921C19.2625 6.50276 20.2554 8.13933 20.6879 9.95775C21.1205 11.7762 20.9708 13.6845 20.2601 15.4133C19.8074 16.4965 19.1485 17.4814 18.3201 18.3133Z"
                                                    fill="white" />
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!----------end of Social Links--------->
                    </div>
                </div>
                <!----Start of navigation ------------>
                <div class="col-lg-2 col-sm-6">
                    <!-- <div class="row gx-lg-5 w-100">
                        <div class="col-md-6"> -->
                    <div class="whoWeAre">
                        <h3 class="h5"></h3>
                        <router-link :to="{ path: `/${$i18n.locale}` }" exact>
                            <p>
                                {{ $t("home") }}
                            </p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/about` }" exact>
                            <p>
                                {{ $t("about_us") }}
                            </p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/contact` }" exact>
                            <p>
                                {{ $t("contact_us") }}
                            </p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/courses` }" exact>
                            <p>
                                {{ $t("courses") }}
                            </p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/blog` }" exact>
                            <p>{{ $t('blogs') }}</p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/reviews` }" exact>
                            <p>
                                {{ $t("reviews") }}
                            </p>
                        </router-link>
                    </div>
                </div>
                <!-------------------2nd Navigation column------------>
                <div class="col-lg-2 col-sm-6">
                    <div class="whoWeAre">
                        <router-link :to="{ path: `/${$i18n.locale}/complains` }">
                            <p> {{ $t("suggestions_complaints") }} </p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/blog` }">
                            <p>{{ $t("blogs") }}</p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/partners` }"  exact>
                           <p>{{ $t('partners') }}</p>
                        </router-link>
                        <!-- <router-link :to="{ path: `/${$i18n.locale}/faq` }">
                           <p> {{ $t("faq_title") }}</p>
                        </router-link> -->
                        <router-link :to="{ path: `/${$i18n.locale}/support` }">
                             <p>{{ $t("technical_support") }}</p>
                        </router-link>
                    </div>
                </div>
                <!-----Start of Course Navigation---------------->
                <div class="col-lg-2 col-sm-6">
                    <div class="whoWeAre">
                        <router-link :to="{ path: `/${$i18n.locale}/learning` }" exact>
                            <p>{{ $t("remote_learning") }}</p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/terms-conditions` }" exact>
                            <p>{{ $t("privacy_policy") }}</p>
                        </router-link>
                        <!-- <router-link :to="{ path: `/${$i18n.locale}/privacy-policy` }" exact>
                            <p>{{ $t("privacy_policy") }}</p>
                        </router-link> -->
                        <router-link :to="{ path: `/${$i18n.locale}/terms` }" exact>
                            <p>{{ $t("terms_conditions") }}</p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/faq` }" exact>
                            <p>{{ $t("faq_title") }}</p>
                        </router-link>
                    </div>
                </div>
                <!------End Of Course Navigation---------->
                <!-----Start Of Applications------------------>
                <div class="col-lg-3 col-md-12 d-flex d-lg-block flex-wrap align-items-center justify-content-center">
                    <div class="application">
                        <h4 class="h5">{{ $t('content.downloadApp') }}</h4>
                        <div class="apps py-3 d-flex align-items-center gap-3 flex-wrap justify-content-center">
                            <router-link class="apple flex-grow-1" role="button" :to="{ path: `/${$i18n.locale}/app/ios` }">
                                <p class="app-text">App Store</p>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M19.1001 19.16C19.6901 18.26 19.9101 17.8 20.3601 16.79C17.0401 15.53 16.5101 10.8 19.7901 8.99C18.7901 7.73 17.3801 7 16.0501 7C15.0901 7 14.4301 7.25 13.8401 7.48C13.3401 7.67 12.8901 7.84 12.3301 7.84C11.7301 7.84 11.2001 7.65 10.6401 7.45C10.0301 7.23 9.39007 7 8.59007 7C7.10007 7 5.51007 7.91 4.50007 9.47C3.08007 11.67 3.33007 15.79 5.62007 19.31C6.44007 20.57 7.54007 21.98 8.97007 22C9.57007 22.01 9.96007 21.83 10.3901 21.64C10.8801 21.42 11.4101 21.18 12.3401 21.18C13.2701 21.17 13.7901 21.42 14.2801 21.64C14.7001 21.83 15.0801 22.01 15.6701 22C17.1201 21.98 18.2801 20.42 19.1001 19.16ZM15.8401 2C16.0001 3.1 15.5501 4.19 14.9601 4.95C14.3301 5.77 13.2301 6.41 12.1701 6.37C11.9801 5.31 12.4701 4.22 13.0701 3.49C13.7401 2.69 14.8701 2.07 15.8401 2Z"
                                        fill="white" />
                                </svg>
                            </router-link>
                            <router-link class="googlePlay flex-grow-1" role="button" :to="{ path: `/${$i18n.locale}/app/android` }">
                                <p class="app-text">Google Play</p>
                                <svg width="24" height="24" viewBox="0 0 21 18" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.6829 9.97253L16.8624 11.3625C16.6696 11.4625 16.4363 11.4225 16.2739 11.2725L14.3767 9.40253C14.1737 9.20253 14.1737 8.89253 14.3767 8.69253L16.3044 6.79253C16.4566 6.64253 16.7001 6.60253 16.8928 6.70253L19.6829 8.08253C20.4844 8.46253 20.4844 9.58253 19.6829 9.97253ZM14.5086 5.51353C14.8231 5.66353 14.8839 6.07353 14.6404 6.31353L12.9461 7.98353L12.2257 8.69353C12.0228 8.89353 11.7083 8.89353 11.5054 8.69353L4.26126 1.55453C3.85644 1.15453 4.33228 0.504531 4.84972 0.754531L14.5086 5.51353ZM1.17659e-05 17.1725V0.502531C1.17659e-05 0.0625312 0.537741 -0.167469 0.862408 0.142531L9.7603 8.65253C9.97337 8.85253 9.96322 9.18253 9.75016 9.38253L0.852262 17.5425C0.779674 17.6089 0.688973 17.6529 0.591338 17.669C0.493704 17.6852 0.393403 17.6728 0.302801 17.6335C0.212198 17.5942 0.135253 17.5296 0.0814498 17.4477C0.0276468 17.3657 -0.000662382 17.2701 1.17659e-05 17.1725ZM14.4781 12.5415L4.95118 17.2415C4.43374 17.4915 3.95689 16.8415 4.36272 16.4415L11.5155 9.39153C11.7184 9.19153 12.033 9.19153 12.2359 9.39153L14.6202 11.7415C14.8535 11.9815 14.7825 12.3915 14.4781 12.5415Z"
                                        fill="white" />
                                </svg>
                            </router-link>
                        </div>
                        <div class="cards flex-wrap">
                            <div class="img-bg mt-1">
                                <img loading="lazy" src="../../assets/images/layout/cards/PayPal.webp" alt="paypal logo"
                                    width="53" height="53" />
                            </div>
                            <div class="img-bg-1 mt-1">
                                <img loading="lazy" src="../../assets/images/layout/cards/Mastercard.webp"
                                    alt="master logo" width="95" height="78" class="img-1" />
                            </div>
                            <div class="img-bg-1 mt-1">
                                <img loading="lazy" src="../../assets/images/layout/cards/Visa.webp" alt="Visa logo"
                                    width="95" height="78" class="img-2" />
                            </div>
                            <div class="img-bg mt-1">
                                <img loading="lazy" src="../../assets/images/layout/cards/mada.webp" alt="Mada logo"
                                    width="53" height="53" />
                            </div>
                            <div class="img-bg mt-1">
                                <img loading="lazy" src="../../assets/images/layout/cards/Pay.webp" alt="Pay logo"
                                    width="53" height="53" />
                            </div>
                        </div>
                    </div>
                </div>
                <!--end of applications----------------->
            </div>
            <!------start Of Copy right---------------->
            <hr />
            <div class="d-flex justify-content-between gap-3  footer-rights  align-items-center flex-wrap">
                    <div id="footer-desc">
                        <p >{{ $t("footer_rights_reserved") }}</p>
                    </div>

                    <div id="rights"  class="d-flex align-items-center gap-3 flex-wrap align-self-end" >
                        <router-link :to="{ path: `/${$i18n.locale}/terms-conditions` }">
                            <p>{{ $t("privacy_policy") }}</p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/learning` }">
                            {{ $t("remote_learning") }}
                        </router-link>
                        <!-- <router-link :to="{ path: `/${$i18n.locale}/terms-conditions` }">
                            {{ $t('property-rights-protection') }}
                        </router-link> -->
                        <router-link :to="{ path: `/${$i18n.locale}/terms` }">
                            {{ $t("terms_conditions") }}
                        </router-link>
                      <router-link :to="{ path: `/${$i18n.locale}/attendance-policy` }">
                        {{ $t("attendance-policy") }}
                      </router-link>
                      <router-link :to="{ path: `/${$i18n.locale}/communication-policy` }">
                        {{ $t("communication-policy") }}
                      </router-link>
                        <!-- <router-link :to="{ path: `/${$i18n.locale}/faq` }">
                            {{ $t("faq_title") }}
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/support` }">
                             {{ $t("technical_support") }}
                        </router-link> -->
                        <!-- <p class="pt-2">{{ $t("footer_supported_by") }}</p> -->
                    </div>
            </div>
            <!-------------------------->
        </div>
    </footer>
</template>
<script>
export default {
    name: "FooterItem",
    date() {
        return {
            footerData: {
                general: {
                    instagram: "https://instagram.com",
                    twitter: "https://twitter.com",
                    facebook: "https://facebook.com",
                },
            },
        };
    },
};
</script>
<style lang="scss" scoped>
p {
    margin-bottom: 0px
}

.footer {
    background-color: #206387;
    position: relative;
    background-repeat: no-repeat;
    background-image: url('../../assets/images/footerbg.webp');
    background-size: contain;
    background-position: 10px center;
    width: 100%;
}

.footer .linkedin {
    background-color: #fff;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin: 0 7px;
}

a {
    text-decoration: none !important;
}

.apple,
.googlePlay {
    svg {
        flex-shrink: 0;
    }
}

.footer .application .h5,
.footer p,
.footer,
.search-input svg,
.whoWeAre a,
.customersService p,
.apps .app-text,
.footer #footer-desc p {
    color: #fff;
}
.footer-rights{
    padding: 30px 0;
}
@media screen and (max-width: 992px){
    .footer-rights{

        padding-bottom: 63px;
    }
}
#rights a{
    color: #FFF;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 2rem;
    transition: .2s ease-in-out;

    &:hover{
        color: aqua;
         transform: translateY(-2px);
    }
}
.footer #rights p {
    &:lang(en) {
        font-weight: 400;
    }
}

.footer p {
    font-size: 1rem;
    line-height: 1.6;
    font-weight: 400;
    text-transform: capitalize;
}

.footer .application .h5 {
    font-size: 1.25rem;
    text-align: center;
    font-weight: 700;
}

.search-input {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;

    input {
        border: none;
        outline: none;
        padding: 11px;
        width: 100%;
        border-radius: 5px 0px 0px 5px;

        &:lang(en) {
            border-radius: 5px 0px 0px 5px;
        }

        &:lang(ar) {
            border-radius: 0px 5px 5px 0px;
        }

        &:focus+.icon svg,
        &:focus-visible+.icon svg {
            -webkit-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            transform: rotate(360deg);
        }

        &::-webkit-input-placeholder {
            color: rgba(105, 105, 115, 0.4);
        }

        &::-moz-placeholder {
            color: rgba(105, 105, 115, 0.4);
        }

        &:-ms-input-placeholder {
            color: rgba(105, 105, 115, 0.4);
        }

        &::-ms-input-placeholder {
            color: rgba(105, 105, 115, 0.4);
        }

        &::placeholder {
            color: rgba(105, 105, 115, 0.4);
        }
    }

    .icon {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        width: 18%;
        background-color: #f29012;
        border-radius: 0px 7px 7px 0px;

        &:lang(en) {
            border-radius: 0px 7px 7px 0px;
        }

        &:lang(ar) {
            border-radius: 7px 0px 0px 7px;
        }

        svg {
            -webkit-transition: all 0.4s ease-in-out;
            -o-transition: all 0.4s ease-in-out;
            transition: all 0.4s ease-in-out;
        }
    }
}

.footer .paymentMethod svg {
    margin: 0px 5px;
}

.whoWeAre p,
.customersService p {
    font-size: 1rem;
    font-weight: 400;
    margin-bottom: 13px;
    -webkit-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
}
.whoWeAre a {
  &.router-link-exact-active {
    p{
        color: #17a9e3;
        font-weight: 700;
    }
  }
}

.customersService a:hover,
.whoWeAre a:hover {
    p {
        color: antiquewhite;
        &:lang(ar){
            -webkit-transform: translateX(-10px);
            -ms-transform: translateX(-10px);
            transform: translateX(-10px);
        }
        &:lang(en){
            -webkit-transform: translateX(10px);
            -ms-transform: translateX(10px);
            transform: translateX(10px);
        }
    }
}

.social a svg {
    -webkit-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
}

.social a:hover {
    cursor: pointer;

    svg {
        -webkit-transform: translateY(5px) !important;
        -ms-transform: translateY(5px) !important;
        transform: translateY(5px) !important;
    }
}

.apps {
    .app-text {
        font-size: .8rem;
        font-weight: 500;
        line-height: 1.25rem;
        letter-spacing: 0.15px;
        white-space: nowrap;
    }

    .apple,
    .googlePlay {
        .app-text {
            font-optical-sizing: auto;
            font-weight: 400;
            margin-bottom: 0;
            font-weight: 600;
            line-height: 1.25rem;
            letter-spacing: 0.15px;
        }

        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        gap: 10px;
        border-radius: 4px;
        padding: 8px 15px;
        border: 2px solid #fff;
    }
}

.footer #footer-desc p {
    color: #FFF;
    font-size: 0.75rem;
    font-weight: 400;
}

hr {
    border: 1px solid #fff;
    margin-top: 40px;
}

.social {
    z-index: 4;
}

.cards .img-bg,
hr,
.search-input input {
    background: #fff;
}

.cards {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: 24px;

    .img-bg,
    .img-bg-1,
    .img-bg-2 {
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        text-align: center;
        width: 52.5px;
        height: 35px;
    }

    .img-bg {
        -ms-flex-negative: 0;
        flex-shrink: 0;
        border-radius: 6px;
        -webkit-box-shadow: 0px 13px 24px 0px rgba(0, 0, 0, 0.11),
            0px 5.431px 10.027px 0px rgba(0, 0, 0, 0.08),
            0px 2.904px 5.361px 0px rgba(0, 0, 0, 0.07),
            0px 1.628px 3.005px 0px rgba(0, 0, 0, 0.05),
            0px 0.865px 1.596px 0px rgba(0, 0, 0, 0.04),
            0px 0.36px 0.664px 0px rgba(0, 0, 0, 0.03);
        box-shadow: 0px 13px 24px 0px rgba(0, 0, 0, 0.11),
            0px 5.431px 10.027px 0px rgba(0, 0, 0, 0.08),
            0px 2.904px 5.361px 0px rgba(0, 0, 0, 0.07),
            0px 1.628px 3.005px 0px rgba(0, 0, 0, 0.05),
            0px 0.865px 1.596px 0px rgba(0, 0, 0, 0.04),
            0px 0.36px 0.664px 0px rgba(0, 0, 0, 0.03);

        img {
            width: 100%;
        }
    }

    .img-1,
    .img-2 {
        width: 95px;
        margin-top: 26px;
    }
}

p.desc {
    line-height: 1.9
}

.footer #rights p {
    font-size: 0.75rem;
    font-weight: 800;
}

@media screen and (max-width: 600px) {
    .footer .last {
        display: block !important;
    }
}

@media screen and (max-width: 768px) {
    hr {
        margin-top: 60px;
    }
}
</style>
